import { environment } from "../config/environment";

export const useEnvironment = () => {
  return {
    isProduction: environment.environment === "production",
    isDevelopment: environment.environment === "development",
  };
};
